import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=0c501115&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=0c501115&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c501115",
  null
  
)

export default component.exports